<template>
  <div>
    <v-layout column class="mt-3">
      <section-header v-if="!this.field.sub_field" text="Links" @showAdd="showEditDialog=true" :showAddLink="true"></section-header>
      <subsection-header v-else text="Links" link="true" @showAdd="showEditDialog=true" :showAddLink="true"></subsection-header>
      <!-- <v-flex class="mt-0 mb-0 xs12 right" v-show="!showEditDialog" style="position: relative; top: -32px; height:30px;"> -->
        <!-- <v-btn small round @click="showEditDialog=!showEditDialog">
          <v-icon small>add</v-icon> Add new Link
        </v-btn> -->
          <!-- color="white" -->
      <!-- </v-flex> -->
      <!-- <v-card color="grey lighten-5" class="mb-5 px-3 pb-3"> -->
      <v-flex :class="[{'mx-2': this.field.sub_field}, 'xs12', 'sm12', 'md12', 'mt-0', 'pt-0']">
        <!-- <h4 class="title mb-2">Upload {{uploadCategory}} – 4 files uploaded -->
        <!-- </h4> -->
        <v-list class="xs12 pl-0" two-line style="background-color:#ececec;" v-if="links">
          
          <v-list-tile v-for="f in links" :key="f.id" class="pl-0 ml-0">
            <v-list-tile-content>
              <v-list-tile-title>
                <a round flat small :href="f.www" target="_blank" class="px-0 ml-0">
                  <v-icon small class="mr-2">launch</v-icon>
                  <b>{{ f.title ? f.title : f.www }}</b>
                </a>
              </v-list-tile-title>
              <v-list-tile-sub-title class="text-no-wrap">{{f.description}}</v-list-tile-sub-title>
              </v-list-tile-content>              
              <!-- <a target="_blank" :href="f.www"> -->
            <v-flex>
              <v-btn @click="edit_link(f)" icon small ><v-icon small>edit</v-icon></v-btn>
            </v-flex>
            <v-flex v-if="c_user.edit">
              <v-btn small @click="delete_link(f)" icon >
                <v-icon small>delete</v-icon>
              </v-btn>
            </v-flex>
            <hr></hr>
          </v-list-tile>
          <!-- <v-divider></v-divider> -->
        </v-list>

        <v-flex v-if="c_user.edit">
          <!-- <v-flex class="mt-0 mb-0 xs12" v-show="showEditDialog">
              <v-btn icon @click="showEditDialog=!showEditDialog"><v-icon>close</v-icon></v-btn>
              Cancel
          </v-flex>-->
          <v-flex v-if="showEditDialog">
              <v-container grid-list-xs fluid class="elevation-1 white mt-3">
                <v-layout row wrap px-3>
                  <!-- <h4 class="subheadline xs12">Add new link</h4> -->
                  <v-flex class="xs12">
                    <v-text-field v-model="link.www" label="URL *" prepend-inner-icon="launch"></v-text-field>
                    <!-- append-outer-icon="open_in_new" @click:append="goto" -->
                  </v-flex>
                  <v-flex class="xs12">
                    <v-text-field v-model="link.title" label="Title"></v-text-field>
                  </v-flex>
                  <v-flex class="xs12">
                    <v-textarea rows="1" auto-grow v-model="link.description" label="Description"></v-textarea>
                  </v-flex>
                  <v-flex class="xs12">
                    <v-progress-linear width="2" indeterminate v-if="saving" :color="save_error ? 'red' : 'black'"></v-progress-linear>
                    <v-btn class="right black white--text" v-if="!editing" @click="save_link"  :disabled="link.www.length < 3">save</v-btn>
                    <v-btn class="right black white--text" v-if="editing" @click="save_edited_link"  :disabled="link.www.length < 3">save</v-btn>
                    <v-btn class="right" flat @click="showEditDialog=!showEditDialog">cancel</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
          </v-flex>
        </v-flex>
      </v-flex>
      <!-- </v-card> -->
    </v-layout>
  </div>
</template>

<script>
import EditFieldSub from './EditFieldSub'
// import languages from '@/data/languages'
import axios from 'axios'
import SectionHeader from '../layout/SectionHeader.vue'
import SubSectionHeader from '../layout/SubSectionHeader.vue'

// const show_field = (field, link) => {
//   if (field.condition && link) {
//     var theInstructions = field.condition
//     var F = theInstructions => {}
//     return F()
//   } else {
//     return true
//   }
// }
export default {
  props: ['artwork', 'field'],
  data: () => ({
    // links: [],
    saving: false,
    editing: false,
    save_error: false,
    // links: [
    //   { id:1, title: 'Link 1', url: 'www.google.com', description: 'link description text'},
    //   { id:2, title: 'Link 2', url: 'www.google.com', description: 'link description text'},
    //   { id:3, title: 'Link 3', url: 'www.google.com', description: 'link description text'},
    // ],
    showEditDialog: false,
    show: false,
    link: {
      title: '',
      www: '',
      description: ''
    },
    fields: [
      {
        ctype: 'text-short',
        name: 'link.title',
        title: 'Title',
        column: true,
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      },
      {
        ctype: 'text-short',
        name: 'www',
        title: 'URL',
        column: true,
        preffix: 'http://',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      },

      {
        ctype: 'text-long',
        name: 'description',
        title: 'Description',
        column: true,
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }
    ]
  }),
  methods: {
    save_link () {
      if (!this.link.www.match(/^[a-zA-Z]+:\/\//)) {
        this.link.www = 'http://' + this.link.www
      }
      this.saving = true
      this.link.created_by = this.c_user.id
      this.link.category = this.field.category
      this.link.artwork_id = this.artwork.id
      if (!this.artwork.links) {
        this.artwork.links = []
      }
      axios
        .post(`${this.$globals.apiserver}/links.json`, {
          link: this.link
        })
        .then(response => {
          this.errors = {}
          this.artwork.links.push(response.data)
          this.$store.commit('ADD_LINK', response.data)
          this.showEditDialog = !this.showEditDialog
          this.link = {
            title: '',
            www: '',
            description: ''
          }
          this.saving = false
        })
        .catch(error => {
          // console.log(error)
          this.save_error = true
        })
    },
    save_edited_link () {
      // console.log('save_edited_link')
      if (this.link.created_by == null) {
        this.link.created_by = this.c_user.id
      }
      if (!this.link.www.match(/^[a-zA-Z]+:\/\//)) {
        this.link.www = 'http://' + this.link.www
      }
      this.saving = true
      // this.link.artwork_id = this.artwork.id;
      // if (!this.artwork.links) {
      //   this.artwork.links = [];
      // }
      let url = `${this.$globals.apiserver}/links/${this.link.id}.json`
      axios
        .put(url, {
          link: this.link
        })
        .then(response => {
          this.errors = {}
          this.artwork.links = [
            ...this.artwork.links.map(item =>
              item.id !== response.data.id
                ? item
                : { ...item, ...response.data }
            )
          ]
          this.$store.commit('SAVE_LINK', response.data)
          this.showEditDialog = !this.showEditDialog
          this.link = {
            title: '',
            www: '',
            description: ''
          }
          this.saving = false
          this.editing = false
        })
        .catch(error => {
          this.save_error = true
        })
    },
    // set_input (f) {
    //   link[f] = f
    // },
    // download () {},
    delete_link (link) {
      var i = this.artwork.links.indexOf(link)
      if (i != -1) {
        this.artwork.links.splice(i, 1)
      }
      this.$store.dispatch('deleteLink', link)
    },
    edit_link (l) {
      this.saving = false
      this.editing = true
      this.showEditDialog = true
      try {
        this.link = Object.assign(
          {},
          this.artwork.links.find(t => t.id == l.id)
        )
      } catch (error) {
        // console.log(error.message)
      }
    }
    // show_field_c (field) {
    //   // console.log(this.link)
    //   return show_field(field, this.link)
    // }
  },
  computed: {
    links () {
      if (this.artwork.links && this.artwork.links.length > 0) {
        return this.artwork.links.filter(l => l.category === this.field.category)
      } else {
        return null
      }
    }
    // c_user () {
    //   return this.$store.state.user.profile
    // }
  },
  components: {
    'edit-field-a': EditFieldSub,
    'section-header': SectionHeader,
    'subsection-header': SubSectionHeader
  }
}
</script>

<style scoped>
/* a:hover { text-decoration: underline;} */
/* .card { min-width:250px;} */
</style>



// WEBPACK FOOTER //
// src/components/artworks/Links.vue